export const formatValues = (value: any) => {
    return new Intl.NumberFormat('de-CH', { style: 'currency', currency: 'CHF' }).format(value).replace('CHF', '');
}
